// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"style__contentWrapper__lq0-x","fixContainer":"style__fixContainer__9oB8I","body":"style__body__MhXws"};